import React from 'react';
import styles from './PlatformsTable.module.scss';

import _ from 'lodash';
import moment from "moment";
import { $t } from "../../helpers/translator";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import api from "../../helpers/api";
import Input from "../miscellaneous/Input/Input";
import { connect } from "react-redux";
import { getClinics } from "../../store/data-slice";
import DataTable from "../miscellaneous/DataTable/DataTable";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import { BsCheckCircle } from "react-icons/bs";
import { GrUpdate } from "react-icons/gr";
import { Link } from "react-router-dom";
import Timestamp from "../miscellaneous/Timestamp/Timestamp";
import { BiWifi, BiWifiOff } from "react-icons/bi";


class PlatformsTable extends React.Component {
    constructor(props) {
        super(props);
        const filters = props.filters ? props.filters : {};
        const statusOptions = [
            { label: $t('global.service.all'), value: 'all' },
            { label: $t('global.machinesUsage.online'), value: 'online' },
            { label: $t('global.machinesUsage.offline'), value: 'offline' },
        ];
        const connectionStatus = filters.connectionStatus !== undefined ? filters.connectionStatus : 'all'
        this.state = {
            userType: 2,    //setting type clinic as default
            platforms: [],
            updateKey: 0,

            pagination: null,
            payload: {
                sort: 'created_at',
                order: 'asc',   // or desc
                search: '',
                clinic: '',   // or id
                connectionStatus: connectionStatus,
                page: 1,
                per_page: 15,
                // start_date: moment().subtract(30, 'years'),
                // end_date: moment(),
                distributor_id: props.distributorId ? props.distributorId : '',
                attachmentStatus: this.props.attachmentStatus !== undefined ? this.props.attachmentStatus : 'all'
            },
            tableLoading: false,
            getUsage: props.getUsage !== undefined ? props.getUsage : true,
            sortingOptions: [ {
                label: $t('global.machines.platformName'), value: 'machine_name'
            }, {
                label: $t('global.machines.platformId'), value: 'machine_id'
            }, {
                label: $t('global.applicators.dateAdded'), value: 'created_at'
            }, ],
            selectedSortingOption: {
                label: $t('global.applicators.dateAdded'), value: 'created_at'
            },
            attachedDetachedOptions: [ {
                label: $t('global.machines.modes.all'), value: 'all'
            }, {
                label: $t('global.machines.modes.attached'), value: 'attached'
            }, {
                label: $t('global.machines.modes.detached'), value: 'detached'
            } ],
            clinicOptions: [ {
                label: $t('global.applicators.allClinics'), value: ''
            }, ],
            selectedClinicOption: [ {
                label: $t('global.applicators.allClinics'), value: ''
            }, ],
            statusOptions: statusOptions,
            selectedStatusOption: statusOptions.find(option => {
                const offlineValue = connectionStatus ? connectionStatus : 'all';
                return option.value === offlineValue;
            }),
            selectedAttachedDetachedOption: {
                label: $t('global.machines.modes.all'), value: 'all'
            },
            searchString: '',

        };
    }

    async componentDidMount() {
        let state = this.state;

        if (this.props.perPage) {
            state.payload.per_page = this.props.perPage;
        }

        if (this.props.clinicId) {
            state.payload.clinic = this.props.clinicId;
        }

        if (this.props.userType && this.props.userType !== 2) {
            state.userType = this.props.userType;
        }

        this.setState(state, async () => {
            await this.getPlatforms();
            await this.getClinics();
        })
    }

    getAPIUrl() {
        let payload = { ...this.state.payload };
        return `platform?sort=${payload.sort}&order=${payload.order}&clinic=${payload.clinic}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&get_usage=${this.state.getUsage}&distributor_id=${payload.distributor_id}&attachmentStatus=${payload.attachmentStatus}&connectionStatus=${payload.connectionStatus}`;
    }

    async getPlatforms() {
        this.setState({ tableLoading: true }, async () => {
            try {
                let res = await api.get(this.getAPIUrl());

                let pagination = null;
                let platforms = [];
                if (res && res.success) {
                    this.setState({ platforms: [], pagination: pagination }, () => {
                        _.forEach(res.data.data.data, (v, k) => {
                            v.clinic_name = v.clinic_id ?
                                <Link to={ `/clinic/${v.clinic_id}` }>{ v.clinic_name }</Link> : <Tooltip content={ $t('global.machines.platformDetached') }><span className={ `${styles.detached}` }>
                                    { $t('global.machines.detached') }
                                </span></Tooltip>;
                            v.machine_name = <Link to={ `/equipment/platform/${v.id}` }>{ `${v.machine_name}` }</Link>;
                            if (v.hasOwnProperty('update_required')) {
                                v.update_required = v.update_required ?
                                    <Tooltip content={ $t('global.machines.updateRequired') }><GrUpdate
                                        className={ styles.red } /></Tooltip>
                                    :
                                    <Tooltip content={ $t('global.machines.upToDate') }><BsCheckCircle
                                        className={ styles.green } /></Tooltip>
                            }

                            const checkIsUnlimited = (date) => {
                                return date && moment(date).year() >= 2099;
                            }

                            platforms.push(v)
                            v.days_since_last_connected = v.last_connected ? moment().diff(moment(v.last_connected), 'days') : -1;
                            v.last_connected = <Timestamp time={ v.last_connected } />
                            v.online_status = this.getConnectionStatusLogo(v);
                            v.time_limit = v.time_limit ? checkIsUnlimited(v.time_limit) ? 'Unlimited' : v.time_limit : 'N/A';
                            v.time_limit_alma = v.time_limit_alma ? checkIsUnlimited(v.time_limit_alma) ? 'Unlimited' : v.time_limit : 'N/A';
                        })

                        pagination = res.data.data.pagination;
                        this.setState({
                            platforms: platforms,
                            pagination: pagination,
                            updateKey: this.state.updateKey + 1
                        });
                    })
                }

            } catch (e) {
                console.error('err get platforms:', e);
            } finally {
                this.setState({ tableLoading: false });
            }
        });
    }

    getConnectionStatusLogo(v) {
        // console.log(v.last_connected_at)
        if (v.is_online === true) {
            return (
                <Tooltip
                    content={ `${$t('global.machines.lastConnected')}: ${v.last_connected_at}` }>
                    <BiWifi style={ {
                        color: '#67a14b',
                        fontSize: '20px'
                    } } />
                </Tooltip>
            )
        } else if (v.is_online === false) {
            return (
                <Tooltip
                    content={ `${$t('global.machines.lastConnected')}: ${v.last_connected_at}` }>
                    <BiWifiOff style={ {
                        color: '#DC3545',
                        fontSize: '20px'

                    } } />
                </Tooltip>
            )
        } else {
            return (
                <Tooltip
                    content={ `${$t('global.machines.lastConnected')}: Unknown` }>
                    <BiWifiOff style={ {
                        color: '#FFC107',
                        fontSize: '20px'

                    } } />
                </Tooltip>
            )
        }
    }

    async getClinics() {
        let clinics = [ ...await this.props.dispatch(getClinics()) ]

        clinics.unshift({
            label: $t('global.applicators.allClinics'), value: ''
        })
        this.setState({ clinicOptions: clinics })
    }

    dataTableActionHandler(data) {
        if (data.key === 'page') {
            let payload = { ...this.state.payload };
            payload.page = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getPlatforms();
            });
        }

        if (data.key === 'header') {
            // console.log(data.value)

            let payload = { ...this.state.payload }
            if (payload.sort === data.value) {
                payload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            payload.sort = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getPlatforms();
            });
        }
    }

    fieldChangeHandler(name, data) {
        // console.log(name, data)
        if (name === 'applicatorSN') {
            this.setState({
                applicatorNewSN: data.target.value, applicatorNewSNError: ''
            });
            return;
        }

        let payload = { ...this.state.payload };
        let selectedSortingOption = { ...this.state.selectedSortingOption };
        let selectedClinicOption = { ...this.state.selectedClinicOption };
        let selectedStatusOption = { ...this.state.selectedStatusOption };
        let selectedAttachedDetachedOption = { ...this.state.selectedAttachedDetachedOption };
        payload.page = 1;

        if (name === 'sort') {
            payload.sort = data.value;
            selectedSortingOption = data;
        }
        if (name === 'clinic') {
            payload.clinic = data.value;
            selectedClinicOption = data;
        }
        if (name === 'offline') {
            payload.connectionStatus = data.value;
            selectedStatusOption = data;
        }

        if (name === 'attachmentStatus') {
            payload.attachmentStatus = data.value;
            selectedAttachedDetachedOption = data;
        }

        this.setState({
            payload: payload,
            selectedSortingOption: selectedSortingOption,
            selectedClinicOption: selectedClinicOption,
            selectedStatusOption: selectedStatusOption,
            selectedAttachedDetachedOption: selectedAttachedDetachedOption
        }, async () => {
            await this.getPlatforms();
        });
    }

    nameSearchHandler(e) {
        let payload = { ...this.state.payload };
        payload.search = e.target.value;
        payload.page = 1;

        this.setState({ payload: payload }, async () => {
            await this.getPlatforms();
        });
    }

    datesChangeHandler(dates) {
        let payload = { ...this.state.payload };
        payload.start_date = dates.startDate;
        payload.end_date = dates.endDate;

        this.setState({
            payload: payload
        }, async () => {
            // console.log(this.state);
            await this.getPlatforms();
        });
    }

    render() {
        let tableHeaders = [
            !this.props.clinicId && {
                name: $t('global.clinics.clinicName'),
                id: 'clinic_name',
                clickable: true
            },
            {
                name: $t('global.machines.platformName'),
                id: 'machine_name',
                clickable: true
            },
            {
                name: $t('global.machines.platformId'),
                id: 'machine_id',
                clickable: true
            },
            // {
            //     name: $t('global.machines.name'),
            //     id: 'machine_name',
            //     clickable: true
            // },
            // {
            //     name: $t('global.machines.id'),
            //     id: 'machine_id',
            //     clickable: true
            // },
            // {
            //     name: $t('global.machines.type'),
            //     id: 'machine_type',
            //     clickable: true
            // },
            {
                name: $t('global.machines.firmware'),
                id: 'update_required',
                clickable: true
            },
            {
                name: $t('global.patients.lastTreatment'),
                id: 'last_connected',
                clickable: true
            },
            {
                name: "Time Limit",
                id: 'time_limit',
                clickable: true
            },
            {
                name: "Alma Time Limit",
                id: 'time_limit_alma',
                clickable: true
            },
            {
                name: $t('global.machines.status'),
                id: 'online_status',
                clickable: false
            },
        ];

        return (<div className={ styles[ 'container' ] }>
            <div className={ styles[ 'box' ] }>
                <div className={ 'alma-box' }>
                    <div className={ 'alma-box-header' }>
                        <div>
                            <h3>{ $t('global.machines.platforms') }</h3>
                        </div>
                    </div>

                    <div className={ 'alma-fields-row' }>
                        {
                            !this.props.clinicId ?
                                <div className={ 'alma-field-container' }>
                                    <div className={ 'alma-field-header' }>{ $t('global.machines.byClinic') }</div>
                                    <MultiSelect
                                        searchable={ true }
                                        options={ this.state.clinicOptions }
                                        selected={ this.state.selectedClinicOption }
                                        onValueChange={ (data) => this.fieldChangeHandler('clinic', data) }
                                    />
                                </div>
                                :
                                null
                        }

                        {
                            this.props.userType >= 5 ?
                                <div className={ 'alma-field-container' }>
                                    <div
                                        className={ 'alma-field-header' }>{ $t('global.machines.attachedDetached') }</div>
                                    <MultiSelect
                                        options={ this.state.attachedDetachedOptions }
                                        selected={ this.state.selectedAttachedDetachedOption }
                                        onValueChange={ (data) => this.fieldChangeHandler('attachmentStatus', data) }
                                    />
                                </div>
                                :
                                null
                        }

                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.machines.onlineStatus') }</div>
                            <MultiSelect
                                options={ this.state.statusOptions }
                                selected={ this.state.selectedStatusOption }
                                onValueChange={ (data) => this.fieldChangeHandler('offline', data) }
                            />
                        </div>

                        {/*<div className={'alma-field-container'}>*/ }
                        {/*    <div className={'alma-field-header'}>{$t('global.machines.sortBy')}</div>*/ }
                        {/*    <MultiSelect*/ }
                        {/*        options={this.state.sortingOptions}*/ }
                        {/*        selected={this.state.selectedSortingOption}*/ }
                        {/*        onValueChange={(data) => this.fieldChangeHandler('sort', data)}*/ }
                        {/*    />*/ }
                        {/*</div>*/ }

                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.machines.searchPlatform') }</div>
                            <Input name="search"
                                delay={ 500 }
                                className={ 'alma-input' }
                                type="text"
                                value={ this.state.payload.search }
                                placeholder={ $t('global.machines.platformNameOrId') }
                                onChange={ (e) => this.nameSearchHandler(e) } />
                        </div>
                    </div>

                    <div>
                        <DataTable data={ this.state.platforms }
                            headers={ tableHeaders }
                            pagination={ this.state.pagination }
                            loading={ this.state.tableLoading }
                            apiUrl={ this.getAPIUrl() }
                            onAction={ (e) => this.dataTableActionHandler(e) }
                        />
                    </div>
                </div>
            </div>
        </div>
        );
    }
}


const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(PlatformsTable);
